import { Component } from 'react';
import Head from 'next/head';

class Meta extends Component {
    render() {
        return (
            <Head>
                <title>{this.props.title}</title>

                <meta charSet="utf-8" />
                <meta httpEquiv='X-UA-Compatible' content='IE=edge' />
                <meta name='viewport' content='width=device-width, initial-scale=1' />
                <meta name="google-site-verification" content="R3Hzv2Nq2mGjlHS_h9kJH3xpApvXNm77uUdgp1MA7UE" />
                <meta name="msvalidate.01" content="40052CAD0B3E04124DAED86081EAD4B5" />
                <meta name="author" content="https://www.bewive.be" />
                
                <meta name="description" content={this.props.description} />
                <meta property="og:url" content={this.props.url} />
                <meta property="og:title" content={this.props.title} />
                <meta property="og:description" content={this.props.description} />
                <meta property="og:image" content="https://www.coeladvocaten.be/static/images/logo_full.png" />
                <meta property="og:site_name" content="https://www.coeladvocaten.be" />
                <meta name="robots" content={this.props.robots} />

                <link rel="canonical" href={this.props.url} />
                
                {
                    this.props.languages.map(lang =>
                        <link rel="alternate" key={lang.language} href={lang.url} hrefLang={lang.language} />        
                    )
                }

                <link rel="icon" href="/static/images/favicon.ico" />
                <link rel="icon" href="/static/images/favicon-32x32.png" sizes="32x32" type="image/png" />
                <link rel="icon" href="/static/images/favicon-16x16.png" sizes="16x16" type="image/png" />

                <link href="https://fonts.googleapis.com/css?family=Abel:100,200,300,400,500,600,700|Oswald:100,200,300,400,500,600,700" rel="stylesheet" type="text/css" />
	            <link href="/static/bootstrap/css/bootstrap.min.css" rel="stylesheet" type="text/css" />
	            <link href="/static/fontawesome/css/all.min.css" rel="stylesheet" type="text/css" />
	            <link href="/static/style.css" rel="stylesheet" type="text/css" />
	            <link href="/static/responsive.css" rel="stylesheet" type="text/css" />
            </Head>
        )
    }
}

export default Meta;
